// import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
// import { HttpErrorResponse } from '@angular/common/http';
import { toWords } from 'number-to-words';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  src;
  payHistory: FormGroup;
  payHistoryData: any;
  addmissionData: any;
  clgName: any;
  CoName: any;
  SnNo: any;
  FeeTable: any;
  TotalPaidAmountInWords: any;
  PreFix: any;
  formattedPrn: string;
  Transcript: boolean;
  TranscriptData: any;
  ExamName: any;
  showExamName = false;
  StuFullName: any;
  OldStudentName: any;
  StudentType: any;
  RegnNo: any;
  TransactionId: any;
  isAttestation: boolean = false;
  isVOD: boolean = false;  // Added for VOD
  isTranscript: boolean = false; // Added for Transcript
  
  constructor(private fb: FormBuilder, public umsService: UmsService,
    public dialogRef1: MatDialogRef<PaymentReceiptComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,) { }
  // listOfFee: any;
  tempCo
  StudentPersonalId
  InstuName
  currentDate
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  Email: string
  StudentId
  feeMode
  payModeee
  TotalPaidAmount
  showDownloadButton = true;
  generatingPDF = false;
  downloadingPDF: boolean = true;
  Currency
  reciptNumber
  RgNo
  debStudent = false
  FullName: any
  // payHistoryData: any;

  // data['college'] = this.CollegeList[0]['CgCode']
  // data['course'] =this.courseList[0]['CoCode'];
  ngOnInit(): void {
    this.debStudent = false;
    // this.Currency = sessionStorage.getItem('Currency')
    this.showExamName = false;
    this.getSecretData();
    this.getUserData(sessionStorage.getItem('StudentRGID'))
    this.prepopulationOfAddmission();
    this.currentDate = new Date();
    this.tempCo = this.data.TemplateCode
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.tempCo = this.data.TemplateCode
    this.StudentId = sessionStorage.getItem('StudentPersonalId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    // this.RgNo = sessionStorage.getItem('StudentRGID');

    this.getPersonalDetails();
  }

  transPRN(RgNo) {
    let RgNo1 = 99999;
    this.formattedPrn = RgNo.toString().padStart(8, '0');
  }


  getData() {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = this.tempCo;
    payload['FeeType'] = ''
    // this.disablePaid = true;
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      this.spinner.hide()
      let data = res.data[0];
      this.Currency = data.Currency
      if (res.status) {
        this.FeeTable = res.data;
      } else {
        // this.umsService.openSnackbar(res.message);
      }
    });
  }


  downloadAsPDF() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `PaymentReceipt_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        // Restore the visibility of the buttons after PDF generation is complete
        buttons.forEach(button => {
          button.style.display = '';
        });
      });
  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']

      if (this.data.FeeType === 'TS') {
        this.isAttestation = false;
        this.isVOD = false;
        this.isTranscript = true;
        this.getTranscriptHistory()
        this.getTranscript()
      }
      else if (this.data.FeeType === 'ATTFE') {
        this.isAttestation = true;
        this.isVOD = false;
        this.isTranscript = false;
        this.getTranscriptHistory()
        this.getTranscript()                
        this.Transcript = false;            
      }
      else if (this.data.FeeType === 'VOD') {
        this.isAttestation = false;
        this.isVOD = true;
        this.isTranscript = false;
        this.getTranscriptHistory()
        this.getTranscript()                
        this.Transcript = false;            
      }
      else {
        this.Transcript = false;
        this.getHistory(res.projectPharam['SnNo']);
      }
      this.InstuName = res.projectPharam['InstituteName']
      this.getData();
    })
  }

  getHistory(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId !== null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    payload['FeeHistory'] = 1;
    payload['SnNo'] = this.data.SnNo;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();
      let data = res.data;
      if ((this.data.CertType == 'ASC' || this.data.CertType == 'RET') && this.data.PaymentResponseId) {
        const filtered = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
        if (filtered.length) {
          data = filtered;
        }
      }
      if (this.data.FeeType === 'ATTFE' && this.data.PaymentResponseId) {
        data = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
      }
      if (this.data.FeeType === 'VOD' && this.data.PaymentResponseId) {
        data = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
      }

      this.payHistoryData = data;
      this.TransactionId = this.payHistoryData[0]?.TransactionId;
      if (!this.payHistoryData[0]?.card_type) {
        this.payModeee = 'Online Payment';
      } else {
        this.payModeee = this.payHistoryData[0].card_type;
      }

      this.reciptNumber = this.payHistoryData[0]?.PaymentResponseID || this.generateSingleFiveDigitReceiptNumber();
      if (res.data[0]?.FeeType == "EF") {
        this.Currency = sessionStorage.getItem('ExamCurrency');
        this.showExamName = true;
      } else {
        this.Currency = this.Currency
        this.showExamName = false;
      }

      if (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') {
        this.TotalPaidAmount = this.payHistoryData.reduce((sum, item) => sum + (item.FeeAmt || 0), 0);
      } else if (this.data.CertType === 'ASC' || this.data.CertType === 'RET') {
        this.TotalPaidAmount = this.payHistoryData.reduce(
          (sum, item) => sum + (Number(item.FeeAmt) || Number(item.FeeAmount) || 0), 0
        );
      } else {
        this.TotalPaidAmount = this.payHistoryData[0]?.TotalPaidAmount
          || this.payHistoryData.reduce((sum, item) => sum + (Number(item.FeeAmt) || Number(item.FeeAmount) || 0), 0);
      }

    this.convert(this.TotalPaidAmount);
  });
}

  // getTranscriptHistory(){
  //   this.spinner.show();
  //   let payload = {};
  //   payload['FeeTemplateCode'] = this.tempCo;
  //   payload['StuId'] = this.StudentPersonalId !== null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
  //   payload['FeeHistory'] = 0;
  //   payload['SnNo'] = this.data.SnNo;
  //   this.umsService.getSearchTranscriptFeeDetails(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     this.payHistoryData = res.data;
  //     this.TransactionId = res.data[0].TransactionId
  //      if(res.data[0].card_type === "" || res.data[0].card_type == "" || res.data[0].card_type == null){
  //       console.log('im inside empty card type');
        
  //       this.payModeee = 'Online Payment'
  //     }
  //     else{
  //       this.payModeee = res.data[0].card_type;
  //     }
  //     this.reciptNumber = res.data[0].PaymentResponseID;
  //     if (res.data[0].FeeType == "EF") {
  //       this.Currency =  sessionStorage.getItem('ExamCurrency')
  //     }
  //     else {
  //       // this.Currency = sessionStorage.getItem('Currency')
  //       this.Currency = this.Currency
  //     }

  //     this.TotalPaidAmount = res.data[0].TotalPaidAmount
  //     this.convert( this.TotalPaidAmount)
  //     const customOrder = [
  //       "Transcript Fee",
  //       "Base Amount",
  //       "Per Additional Set For Transcript",
  //       "Postal Charges",
  //       "Hard Copy",
  //       "Per Additional Set For Delivery",
  //       "Soft Copy",
  //     ];
      
  //     this.payHistoryData = this.payHistoryData.sort((a, b) => {
  //       const normalizeName = (name: string) => {
  //         // Handle dynamic names by removing the "(x Set)" part
  //         return name.replace(/\s*\(\d+\s*Set\)/, "");
  //       };
        
  //       const indexA = customOrder.indexOf(normalizeName(a.FeeHead));
  //       const indexB = customOrder.indexOf(normalizeName(b.FeeHead));
      
  //       // If a name is not in the customOrder array, push it to the end
  //       return (indexA === -1 ? customOrder.length : indexA) - 
  //              (indexB === -1 ? customOrder.length : indexB);
  //     });
  //   })
  // }

  getTranscriptHistory() {
    this.spinner.show();

    const needTranscriptData =
      (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') &&
      !this.TranscriptData;

    if (needTranscriptData) {
      const payload: any = {};
      payload['StuId'] = sessionStorage.getItem('StudentPersonalId') !== null
        ? sessionStorage.getItem('StudentPersonalId')
        : sessionStorage.getItem('StudentRGID');

      this.umsService.SearchTranscript(payload).subscribe((res) => {
        if (res.status) {
          this.TranscriptData = res.data[0];
          this.Transcript = true;
          this.OldStudentName = res.data[0].StuName;
          this.clgName = res.data[0].College;
          this.CoName = res.data[0].Course;
          this.doGetTranscriptHistory();
        } else {
          this.spinner.hide();
        }
      });
    } else {
      this.doGetTranscriptHistory();
    }
  }

  private doGetTranscriptHistory() {
    let payload: any = {};
    payload['FeeTemplateCode'] = this.tempCo;
    payload['StuId'] = this.StudentPersonalId !== null
      ? this.StudentPersonalId
      : sessionStorage.getItem('StudentRGID');
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.data.SnNo;

    this.umsService.getSearchTranscriptFeeDetails(payload).subscribe((res) => {
      this.spinner.hide();

      let data = res.data;

      if (this.data.PaymentResponseId) {
        data = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
      }

      // Handle ATTFE and VOD fee breakdown
      if ((this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') && this.TranscriptData) {
        this.payHistoryData = [];
        const copies = Number(this.TranscriptData.StuCertCopies) || 0;
        const deliveryOpt = this.TranscriptData.DeliveryOpt;
        
        // Base amount for both ATTFE and VOD
        const BASE_AMOUNT = 3050;
        
        // ATTFE has copies fee, VOD does not
        const PER_COPY_FEE = this.isVOD ? 0 : 800;
        const SOFT_COPY_FEE = 800;
        const HARD_COPY_FEE = 2570;
        const PER_COPY_DELIVERY = this.isVOD ? 0 : 800;

        // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
        const isIndiaStudent = this.isVOD ? this.isStudentWithinIndia() : false;
        
        let copiesFee = PER_COPY_FEE * copies;
        let softCopy = 0;
        let hardCopy = 0;
        let perCopyDelivery = 0;
        let postalCharges = 0;
        let totalFee = 0;

        if (deliveryOpt === 'Soft') {
          softCopy = SOFT_COPY_FEE;
          postalCharges = softCopy;
        } else if (deliveryOpt === 'Hard') {
          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          hardCopy = (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;
          perCopyDelivery = (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);
          postalCharges = hardCopy + perCopyDelivery;
        } else if (deliveryOpt === 'Both') {
          softCopy = SOFT_COPY_FEE;
          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          hardCopy = (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;
          perCopyDelivery = (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);
          postalCharges = softCopy + hardCopy + perCopyDelivery;
        }

        totalFee = BASE_AMOUNT + copiesFee + postalCharges;
        const paymentDate = data?.[0]?.FeePaymentDate ? new Date(data[0].FeePaymentDate) : new Date();

        // Add Base Amount
        this.payHistoryData.push({
          FeeHead: this.isVOD ? 'Verification Fee' : 'Base Amount',
          FeeAmt: BASE_AMOUNT,
          FeePaymentDate: paymentDate
        });

        // Only add Copies Fee for ATTFE, not for VOD
        if (!this.isVOD && copiesFee > 0) {
          this.payHistoryData.push({
            FeeHead: `Copies Fee (${copies} Set${copies > 1 ? 's' : ''})`,
            FeeAmt: copiesFee,
            FeePaymentDate: paymentDate
          });
        }

        // For VOD, show copies as 0
        if (this.isVOD) {
          this.payHistoryData.push({
            FeeHead: 'Copies Fee',
            FeeAmt: 0,
            FeePaymentDate: paymentDate
          });
        }

        if (softCopy > 0) {
          this.payHistoryData.push({
            FeeHead: this.isVOD ? 'By Email Charges' : 'By Email Charges Delivery Fee',
            FeeAmt: softCopy,
            FeePaymentDate: paymentDate
          });
        }

        if (hardCopy > 0) {
          this.payHistoryData.push({
            FeeHead: this.isVOD ? 'By Air Mail Charges' : 'By Air Mail Charges Base Fee',
            FeeAmt: hardCopy,
            FeePaymentDate: paymentDate
          });
        }

        if (perCopyDelivery > 0) {
          this.payHistoryData.push({
            FeeHead: 'By Air Mail Charges Delivery Fee',
            FeeAmt: perCopyDelivery,
            FeePaymentDate: paymentDate
          });
        }

        this.TotalPaidAmount = totalFee;
        this.convert(this.TotalPaidAmount);

        if (data && data.length) {
          this.TransactionId = data[0]?.TransactionId;
          this.reciptNumber = data[0]?.PaymentResponseID;
          this.payModeee = data[0]?.card_type ? data[0].card_type : 'Online Payment';
        }

        const customOrder = this.isVOD ? [
          'Verification Fee',
          'Copies Fee',
          'By Email Charges',
          'By Air Mail Charges',
          'By Air Mail Charges Delivery Fee',
        ] : [
          'Base Amount',
          'Copies Fee',
          'Soft Copy Delivery Fee',
          'Hard Copy Delivery Fee',
          'Extra Hard Copy Delivery Charges',
        ];

        this.payHistoryData.sort((a, b) => {
          const idxA = customOrder.findIndex(x => a.FeeHead.includes(x));
          const idxB = customOrder.findIndex(x => b.FeeHead.includes(x));
          return ((idxA === -1 ? customOrder.length : idxA) - (idxB === -1 ? customOrder.length : idxB));
        });

      } else {
        this.payHistoryData = data;
        this.TransactionId = data[0]?.TransactionId;
        this.reciptNumber = data[0]?.PaymentResponseID;

        if (!data[0]?.card_type) {
          this.payModeee = 'Online Payment';
        } else {
          this.payModeee = data[0].card_type;
        }

        if (data[0]?.FeeType == "EF") {
          this.Currency = sessionStorage.getItem('ExamCurrency');
        } else {
          this.Currency = this.Currency;
        }

        this.TotalPaidAmount = data[0]?.TotalPaidAmount || 0;
        this.convert(this.TotalPaidAmount);
      }

      if (this.data.FeeType !== 'ATTFE' && this.data.FeeType !== 'VOD') {
        const customOrder = [
          "Attestation Fee",
          "Base Amount",
          "Per Additional Set For Attestation",
          "Postal Charges",
          "Hard Copy",
          "Per Additional Set For Delivery",
          "Soft Copy",
        ];

        this.payHistoryData = this.payHistoryData.sort((a, b) => {
          const normalizeName = (name: string) => name.replace(/\s*\(\d+\s*Set\)/, "");
          const indexA = customOrder.indexOf(normalizeName(a.FeeHead));
          const indexB = customOrder.indexOf(normalizeName(b.FeeHead));
          return ((indexA === -1 ? customOrder.length : indexA) - (indexB === -1 ? customOrder.length : indexB));
        });
      }
    });
  }

  normalizeFeeHead(name: string): string {
    return name.replace(/\s*\(\d+\s*Set\)/, "");
  }

  // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
  isStudentWithinIndia(): boolean {
    // Prefer DeliverAt when present (the VOD API returns "IN" / "OFI")
    const deliverAt = (this.TranscriptData?.DeliverAt || '').toString().trim().toUpperCase();
    if (deliverAt === 'IN' || deliverAt === 'INDIA') {
      return true;
    }
    if (deliverAt === 'OFI' || deliverAt === 'OUT' || deliverAt === 'OUTSIDE') {
      return false;
    }

    const country = (this.TranscriptData?.Country || this.TranscriptData?.CountryName ||
      this.TranscriptData?.StuCountry || this.TranscriptData?.StuCountryName || '')
      .toString().trim().toLowerCase();

    // If the country is not available in the response, consider the student as within India (no postal charges)
    if (!country) {
      return true;
    }

    return country === 'india' || country === 'ind' || country === 'in' || country === 'bharat';
  }

  isSubhead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return [
      'Per Additional Set For Transcript',
      'Hard Copy',
      'Soft Copy',
      'Base Amount',
      'Per Additional Set For Delivery'
    ].includes(normalized);
  }

  isHead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return ['Transcript Fee', 'Postal Charges'].includes(normalized);
  }

  convert(number) {
    this.TotalPaidAmountInWords = toWords(number);
  }

  getUserData(id) {
    this.FirstName = ''
    this.MiddleName = ''
    this.LastName = ''
    this.Number = 0
    this.Email = ''
    this.umsService.getUserData(id).subscribe((res) => {
      // if(res.data[0][0]['StudebID'] != ''){
      //   this.debStudent = true;
      //   this.FullName = res.data[0][0]['StuFullName']
      // }
      this.FirstName = res.data[0][0]['StuFirstName']
      this.MiddleName = res.data[0][0]['StuMidName']
      this.LastName = res.data[0][0]['StuLastName']
      this.Number = parseInt(res.data[0][0]['StuMobNumber'])
      this.Email = res.data[0][0]['StuEmailId']
      this.StudentType = res.data[0][0]['StudentType']
      this.RegnNo = res.data[0][0]['LoginName'];
      //  if ((res.data[0][0]['StuFirstName'] == undefined || res.data[0][0]['StuFirstName'] == null)
      //   || (res.data[0][0]['StuMidName'] == undefined || res.data[0][0]['StuMidName'] == null)
      //   || (res.data[0][0]['StuLastName'] == undefined || res.data[0][0]['StuLastName'] == null)) {
      //   this.StuFullName = this.data.studentname;
      // } else {
      //   this.StuFullName = res.data[0][0]['StuFirstName'] + ' ' + res.data[0][0]['StuMidName'] + ' ' + res.data[0][0]['StuLastName'];

      // }
    });
  }

  close() {
    this.dialogRef1.close();
  }


  prepopulationOfAddmission() {
    // this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] = this.StudentPersonalId !== null ? this.StudentPersonalId : sessionStorage.getItem('StudentRGID');
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.getclg(res.data[0]);
        this.getCourse(res.data[0])
        this.getExam(res.data[0]);
      }
      else {
        // this.clgName = this.data.College
        this.CoName = this.data.Course
        this.PreFix = ''
      }

    }, (ERROR: HttpErrorResponse) => {
      // this.clgName = this.data.College
      this.CoName = this.data.Course
    })
  }

  getclg(data) {
    console.log('datadatadata', data);

    let payload = {};
    payload['CgCode'] = data.StuCgId;
    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.clgName = res.data[0].CgName
        console.log('this.data.College', res.data[0].CgName);
      }
      else {
        console.log('this.data.College', this.data.College);

        this.clgName = this.data.College
      }

    }, (error: HttpErrorResponse) => {
      this.clgName = this.data.College
    })

  }


  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.StuCoId
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      if (res.status) {
        this.CoName = res.data[0].CoName
        this.PreFix = res.data[0].CoRgPrfx
      }
      else {
        this.CoName = this.data.course
      }

    }, (ERROR: HttpErrorResponse) => {
      this.CoName = this.data.course
    })

  }


  generateSingleFiveDigitReceiptNumber(): string {
    const randomNumber = Math.floor(Math.random() * 100000); // Generate random number between 0 and 99999
    const formattedNumber = randomNumber.toString().padStart(5, '0'); // Ensure it's formatted to have 5 digits with leading zeros
    return formattedNumber;
  }
  
  //  getTranscript(){
  //   let payload = {};
  //   payload['StuId'] = sessionStorage.getItem('StudentPersonalId') !== null ? sessionStorage.getItem('StudentPersonalId') : sessionStorage.getItem('StudentRGID');
  //   this.umsService.SearchTranscript(payload).subscribe((res) => {
  //     if(res.status){
  //       this.TranscriptData = res.data[0]
  //       this.Transcript = true;
  //        this.OldStudentName = res.data[0].StuName;
  //        this.clgName = res.data[0].College;
  //        this.CoName = res.data[0].Course;
         
  //     }
  //     else{

  //     }
  //   });
  // }

  getTranscript() {
    let payload: any = {};
    payload['StuId'] = sessionStorage.getItem('StudentPersonalId') !== null
      ? sessionStorage.getItem('StudentPersonalId')
      : sessionStorage.getItem('StudentRGID');

    this.umsService.SearchTranscript(payload).subscribe((res) => {
      if (res.status) {
        this.TranscriptData = res.data[0];
        this.Transcript = true;
        this.OldStudentName = res.data[0].StuName;
        this.clgName = res.data[0].College;
        this.CoName = res.data[0].Course;

        if (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') {
          this.payHistoryData = [];
          const copies = Number(this.TranscriptData.StuCertCopies) || 0;
          const deliveryOpt = this.TranscriptData.DeliveryOpt;
          
          // Base amount for both ATTFE and VOD
          const BASE_AMOUNT = 3050;
          
          // ATTFE has copies fee, VOD does not
          const PER_COPY_FEE = this.isVOD ? 0 : 800;
          const SOFT_COPY_FEE = 800;
          const HARD_COPY_FEE = 2570;
          const PER_COPY_DELIVERY = this.isVOD ? 0 : 800;

          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          const isIndiaStudent = this.isVOD ? this.isStudentWithinIndia() : false;
          
          let copiesFee = PER_COPY_FEE * copies;
          let softCopy = 0;
          let hardCopy = 0;
          let perCopyDelivery = 0;
          let postalCharges = 0;
          let totalFee = 0;

          if (deliveryOpt === 'Soft') {
            softCopy = SOFT_COPY_FEE;
            postalCharges = softCopy;
          } else if (deliveryOpt === 'Hard') {
            // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
            hardCopy = (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;
            perCopyDelivery = (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);
            postalCharges = hardCopy + perCopyDelivery;
          } else if (deliveryOpt === 'Both') {
            softCopy = SOFT_COPY_FEE;
            // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
            hardCopy = (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;
            perCopyDelivery = (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);
            postalCharges = softCopy + hardCopy + perCopyDelivery;
          }

          totalFee = BASE_AMOUNT + copiesFee + postalCharges;
          
          // Add Base Amount
          this.payHistoryData.push({
            FeeHead: this.isVOD ? 'Verification Fee' : 'Base Amount',
            FeeAmt: BASE_AMOUNT,
            FeePaymentDate: new Date()
          });

          // Only add Copies Fee for ATTFE, not for VOD
          if (!this.isVOD && copiesFee > 0) {
            this.payHistoryData.push({
              FeeHead: `Copies Fee (${copies} Set${copies > 1 ? 's' : ''})`,
              FeeAmt: copiesFee,
              FeePaymentDate: new Date()
            });
          }

          // For VOD, show copies as 0
          if (this.isVOD) {
            this.payHistoryData.push({
              FeeHead: 'Copies Fee',
              FeeAmt: 0,
              FeePaymentDate: new Date()
            });
          }

          if (softCopy > 0) {
            this.payHistoryData.push({
              FeeHead: this.isVOD ? 'By Email Charges' : 'Soft Copy Delivery Fee',
              FeeAmt: softCopy,
              FeePaymentDate: new Date()
            });
          }

          if (hardCopy > 0) {
            this.payHistoryData.push({
              FeeHead: this.isVOD ? 'By Air Mail Charges' : 'Hard Copy Base Fee',
              FeeAmt: hardCopy,
              FeePaymentDate: new Date()
            });
          }

          if (perCopyDelivery > 0) {
            this.payHistoryData.push({
              FeeHead: 'Hard Copy Delivery Charges',
              FeeAmt: perCopyDelivery,
              FeePaymentDate: new Date()
            });
          }

          this.TotalPaidAmount = totalFee;
          this.convert(this.TotalPaidAmount);

          const customOrder = this.isVOD ? [
            'Verification Fee',
            'Copies Fee',
            'By Email Charges',
            'By Air Mail Charges',
            'By Air Mail Charges Delivery Fee'
          ] : [
            'Base Amount',
            'Copies Fee',
            'Soft Copy Delivery Fee',
            'Hard Copy Delivery Fee',
            'Extra Hard Copy Delivery Charges'
          ];
          
          this.payHistoryData.sort((a, b) => {
            const idxA = customOrder.findIndex(x => a.FeeHead.includes(x));
            const idxB = customOrder.findIndex(x => b.FeeHead.includes(x));
            return ((idxA === -1 ? customOrder.length : idxA) - (idxB === -1 ? customOrder.length : idxB));
          });
        }
      }
    });
  }

  getExam(data) {
    this.spinner.show();
    const payload = {};
    payload['EmCode'] = 0;
    payload['EmId'] = data.StuEmId;
    this.umsService.fetchExam(payload).subscribe(res => {
      this.ExamName = res.data[0].EmName
    });
  }

  getPersonalDetails() {
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      this.StuFullName = res.data[0].StudentName
      this.transPRN(res.data[0].StuRgNo)
    });
  }
}